import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Tabs, Tab } from 'components/common/tabs/tabs';
import Inputs from 'components/inputs/inputs';
import useAsyncEffect from 'use-async-effect';
import employeeService from 'services/employeeService';
import './employeeEdit.css';

const styles = {
  topNav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
  },
  deleteButton: {
    width: '100%',
  },
  backButton: {
    marginLeft: '0.5rem',
    flex: '1',
  },
  editButton: {
    marginRight: '0.5rem',
    flex: '1',
  },
  employeeDetailsListDiv: {
    overflowY: 'scroll',
    position: 'absolute',
    top: '9.5rem',
    bottom: '0',
    left: '1rem',
    right: '0',
  },
};

export default function EmployeeDetails(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [gender, setGender] = useState('');
  const [geoState, setGeoState] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [basePay, setBasePay] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [dateHired, setDateHired] = useState('');
  const [dateLeft, setDateLeft] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');
  const [payPeriod, setPayPeriod] = useState('');
  const [propertySearch, setPropertySearch] = useState('');

  useAsyncEffect(async () => {
    const id = props.match.params.id;
    const employeeData = await employeeService.getEmployeeDetails(id);
    setFirstName(employeeData.firstName);
    setLastName(employeeData.lastName);
    setEmploymentType(employeeData.employmentType);
    setEmployeeNumber(employeeData.employeeNumber);
    setGender(employeeData.gender);
    setPhone(employeeData.phone);
    setGeoState(employeeData.state);
    setCity(employeeData.city);
    setAddress1(employeeData.address1);
    setAddress2(employeeData.address2);
    setMaritalStatus(employeeData.maritalStatus);
    setBasePay(employeeData.basePay);
    setCardNumber(employeeData.cardNumber);
    setDateHired(employeeData.hiredDate);
    setDateLeft(employeeData.leftDate);
    //setHierarchyId(employeeData.hierarchyId);
    setEmailAddress('TODOOO');
    setPayPeriod('TODOOO');
  }, []);

  const match = (search, checkList) => {
    const searchTerms = search.toLowerCase().split(/(\s+)/).filter((e) => e.trim().length > 2);
    outerloop: for (let searchTerm of searchTerms) {
      innerloop: for (let checkItem of checkList) {
        if (checkItem.indexOf(searchTerm) !== -1)
          continue outerloop;
      }
      return false;
    }
    return true;
  };

  const renderSection = (section) => {
    switch (section) {
      case 'first name':
        if (propertySearch.length > 2 && !match(propertySearch, ['first', 'name'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>First Name:</Form.Label>
            <Inputs.Text placeholder='First Name' value={firstName} onValueChange={setFirstName} />
          </Form.Group>
        );

      case 'last name':
        if (propertySearch.length > 2 && !match(propertySearch, ['last', 'name'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Last Name:</Form.Label>
            <Inputs.Text placeholder='Last Name' value={lastName} onValueChange={setLastName} />
          </Form.Group>
        );

      case 'employee number':
        if (propertySearch.length > 2 && !match(propertySearch, ['employee', 'number', 'employment'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Employee Number:</Form.Label>
            <Inputs.Text placeholder='Employee Number' value={employeeNumber} onValueChange={setEmployeeNumber} />
          </Form.Group>
        );

      case 'email':
        if (propertySearch.length > 2 && !match(propertySearch, ['email'])) return null;
        return (
          <Form.Group className='text-input required-field'>
            <Form.Label required>Email:</Form.Label>
            <Inputs.Email placeholder='Email' value={emailAddress} onValueChange={setEmailAddress} />
          </Form.Group>
        );

      case 'employment type':
        if (propertySearch.length > 2 && !match(propertySearch, ['employee', 'employment', 'type', 'manager'])) return null;
        return (
          <Form.Group>
            <Form.Label>Employment Type:</Form.Label>
            <Tabs onSelect={(key) => setEmploymentType(key)} selection={employmentType}>
              <Tab value='r' title='Regular'></Tab>
              <Tab value='m' title='Manager'></Tab>
            </Tabs>
          </Form.Group>
        );

      case 'gender':
        if (propertySearch.length > 2 && !match(propertySearch, ['gender', 'male', 'female'])) return null;
        return (
          <Form.Group>
            <Form.Label>Gender:</Form.Label>
            <Tabs onSelect={(key) => setGender(key)} selection={gender}>
              <Tab value='m' title='Male'></Tab>
              <Tab value='f' title='Female'></Tab>
            </Tabs>
          </Form.Group>
        );

      case 'phone':
        if (propertySearch.length > 2 && !match(propertySearch, ['phone', 'number'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Phone:</Form.Label>
            <Inputs.Text placeholder='Phone' value={phone} onValueChange={setPhone} />
          </Form.Group>
        );

      case 'state':
        if (propertySearch.length > 2 && !match(propertySearch, ['state', 'address', 'location'])) return null;
        return (
          <Form.Group>
            <Form.Label>State:</Form.Label>
            <StateSelector value={geoState} onChange={setGeoState} />
          </Form.Group>
        );

      case 'city':
        if (propertySearch.length > 2 && !match(propertySearch, ['city', 'address', 'location'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>City:</Form.Label>
            <Inputs.Text placeholder='City' value={city} onValueChange={setCity} />
          </Form.Group>
        );

      case 'address1':
        if (propertySearch.length > 2 && !match(propertySearch, ['address1', 'address', 'location'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Address 1:</Form.Label>
            <Inputs.Text placeholder='Address 1' value={address1} onValueChange={setAddress1} />
          </Form.Group>
        );

      case 'address2':
        if (propertySearch.length > 2 && !match(propertySearch, ['address2', 'address', 'location'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Address 2:</Form.Label>
            <Inputs.Text placeholder='Address 2' value={address2} onValueChange={setAddress2} />
          </Form.Group>
        );

      case 'base pay':
        if (propertySearch.length > 2 && !match(propertySearch, ['base', 'pay', 'salary', 'income', 'money'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Base Pay:</Form.Label>
            <Inputs.Integer placeholder='Base Pay' min='20000' max='400000' value={basePay} onValueChange={(val) => setBasePay(val)} />
          </Form.Group>
        );
      case 'card number':
        if (propertySearch.length > 2 && !match(propertySearch, ['card', 'number'])) return null;
        return (
          <Form.Group className='text-input'>
            <Form.Label>Card Number:</Form.Label>
            <Inputs.Integer placeholder='Card Number' value={cardNumber} onValueChange={(val) => setCardNumber(val)} />
          </Form.Group>
        );

      case 'marital status':
        if (propertySearch.length > 2 && !match(propertySearch, ['marital', 'status', 'married', 'single'])) return null;
        return (
          <Form.Group>
            <Form.Label>Marital Status:</Form.Label>
            <Tabs onSelect={(key) => setMaritalStatus(key)} selection={maritalStatus}>
              <Tab value='single' title='Single'></Tab>
              <Tab value='married' title='Married'></Tab>
            </Tabs>
          </Form.Group>
        );

      case 'date hired':
        if (propertySearch.length > 2 && !match(propertySearch, ['date', 'hired', 'started'])) return null;
        return (
          <Form.Group>
            <Form.Label>Date Hired:</Form.Label>
            <Inputs.Date value={dateHired} onChange={setDateHired} placeholder='Select Date Hired' />
          </Form.Group>
        );

      case 'date left':
        if (propertySearch.length > 2 && !match(propertySearch, ['date', 'left', 'ended'])) return null;
        return (
          <Form.Group>
            <Form.Label>Date Left:</Form.Label>
            <Inputs.Date value={dateLeft} onChange={setDateLeft} placeholder='Select Date Left' />
          </Form.Group>
        );

      case 'pay period':
        if (propertySearch.length > 2 && !match(propertySearch, ['pay', 'period', 'money'])) return null;
        return (
          <Form.Group>
            <Form.Label>Pay period:</Form.Label>
            <Inputs.Select placeholder='Please select pay period' value={payPeriod} onChange={(event) => setPayPeriod(event)}>
              <Inputs.Option value='biweekly' label='Bi-weekly' />
              <Inputs.Option value='weekly' label='Weekly' />
              <Inputs.Option value='monthly' label='Monthly ' />
            </Inputs.Select>
          </Form.Group>
        );

      default:
        return null;
    }
  };

  return (
    <div className='edit-employee'>
      <div style={styles.topNav}>
        <Inputs.Button
          variant='app'
          onClick={() => {
            props.history.push('/EmployeeList');
          }}
          style={styles.editButton}
          label='Cancel'
        />
        =
        <Inputs.Button
          variant='app'
          onClick={() => {
            props.history.push('/EmployeeList/1/edit');
          }}
          style={styles.backButton}
          label='Save'
        />
      </div>
      <div>
        <InputGroup className='mb-3'>
          <InputGroup.Prepend>
            <InputGroup.Text id='basic-addon1'>
              <i className='icons8-search' />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <Inputs.Text placeholder='Filter by propery name' value={propertySearch} onValueChange={setPropertySearch} />
        </InputGroup>
        <div style={styles.employeeDetailsListDiv}>
          {renderSection('first name')}
          {renderSection('last name')}
          {renderSection('employee number')}
          {renderSection('email')}
          {renderSection('employment type')}
          {renderSection('gender')}
          {renderSection('phone')}
          {renderSection('state')}
          {renderSection('city')}
          {renderSection('address1')}
          {renderSection('address2')}
          {renderSection('base pay')}
          {renderSection('card number')}
          {renderSection('marital status')}
          {renderSection('date hired')}
          {renderSection('date left')}
          {renderSection('pay period')}
        </div>
      </div>
    </div>
  );
}

function StateSelector(props) {
  return (
    <Inputs.Select value={props.value} onValueChange={props.onChange} placeholder='Select State'>
      <option value='AL'>Alabama</option>
      <option value='AK'>Alaska</option>
      <option value='AZ'>Arizona</option>
      <option value='AR'>Arkansas</option>
      <option value='CA'>California</option>
      <option value='CO'>Colorado</option>
      <option value='CT'>Connecticut</option>
      <option value='DE'>Delaware</option>
      <option value='DC'>District Of Columbia</option>
      <option value='FL'>Florida</option>
      <option value='GA'>Georgia</option>
      <option value='HI'>Hawaii</option>
      <option value='ID'>Idaho</option>
      <option value='IL'>Illinois</option>
      <option value='IN'>Indiana</option>
      <option value='IA'>Iowa</option>
      <option value='KS'>Kansas</option>
      <option value='KY'>Kentucky</option>
      <option value='LA'>Louisiana</option>
      <option value='ME'>Maine</option>
      <option value='MD'>Maryland</option>
      <option value='MA'>Massachusetts</option>
      <option value='MI'>Michigan</option>
      <option value='MN'>Minnesota</option>
      <option value='MS'>Mississippi</option>
      <option value='MO'>Missouri</option>
      <option value='MT'>Montana</option>
      <option value='NE'>Nebraska</option>
      <option value='NV'>Nevada</option>
      <option value='NH'>New Hampshire</option>
      <option value='NJ'>New Jersey</option>
      <option value='NM'>New Mexico</option>
      <option value='NY'>New York</option>
      <option value='NC'>North Carolina</option>
      <option value='ND'>North Dakota</option>
      <option value='OH'>Ohio</option>
      <option value='OK'>Oklahoma</option>
      <option value='OR'>Oregon</option>
      <option value='PA'>Pennsylvania</option>
      <option value='RI'>Rhode Island</option>
      <option value='SC'>South Carolina</option>
      <option value='SD'>South Dakota</option>
      <option value='TN'>Tennessee</option>
      <option value='TX'>Texas</option>
      <option value='UT'>Utah</option>
      <option value='VT'>Vermont</option>
      <option value='VA'>Virginia</option>
      <option value='WA'>Washington</option>
      <option value='WV'>West Virginia</option>
      <option value='WI'>Wisconsin</option>
      <option value='WY'>Wyoming</option>
    </Inputs.Select>
  );
}